import { api_base_url } from "../../../constants";
import { getAppLocale } from "../../../utils/app-locale";
import { appConfiguration } from "../../../utils/app-starter";
import { API_INSTANCE } from "../../../utils/service-http";


export function getLicenceModelComparator (softwareSelection) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  return API_INSTANCE.post(`${api_base_url}/software-licence-model-comparator?locale=${getAppLocale()}${mainOverrideString}`, {
    softwareSelection
  }).then((success) => {
    return success.data.payload;
  }).catch((error) => {
    throw error;
  });
}
